import React from 'react';
import { IconProps } from './types';

const PDIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4462 10.5534V3.69648H20.3033V10.5534H13.4462Z"
        stroke={fillColor}
        strokeWidth="1.39297"
      />
      <path
        d="M13.4462 20.3034V13.4464H20.3034V20.3034H13.4462Z"
        stroke={fillColor}
        strokeWidth="1.39297"
      />
      <path
        d="M3.69648 10.5534V3.69648H10.5536V10.5534H3.69648Z"
        stroke={fillColor}
        strokeWidth="1.39297"
      />
      <path
        d="M3.69648 20.3034V13.4464H10.5536V20.3034H3.69648Z"
        stroke={fillColor}
        strokeWidth="1.39297"
      />
    </svg>
  );
};

export default PDIcon;
